<script>
import { mapState } from "vuex";

export default {
  name: "DistribDoc",

  computed: {
    ...mapState({
      distributionAgreement: (state) =>
        state.tariffDocs.documents.distributionAgreement,
    }),
  },
};
</script>
<template>
  <div class="distrib-doc" v-html="distributionAgreement" />
</template>

<style lang="scss" scoped>
.distrib-doc {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &:deep(h4) {
    color: var(--text-dark-primary, #212121);

    @include body-1-bold;
  }

  &:deep(p) {
    color: var(--text-dark-primary, #212121);

    @include body-1;
  }

  &:deep(ul) {
    display: flex;
    flex-direction: column;
    gap: 8px;

    > li {
      color: var(--text-dark-primary, #212121);

      @include body-1;
    }
  }
}
</style>
